import { render, staticRenderFns } from "./FloatingInfo.vue?vue&type=template&id=52d6aa79&"
import script from "./FloatingInfo.vue?vue&type=script&lang=js&"
export * from "./FloatingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports